import http from "@/shared/services/http";
import {LadingParams} from "@/modules/ladings/params";
import {appStorage} from "@/shared/services/storage";
import {Lading} from "@/interfaces/entity";
import { message } from "ant-design-vue";

export const createLading = (data: any) => http.post(`v1/customer/bill-ladings`, data);
export const createLadingImage = (data: any) => http.post(`v1/customer/bill-ladings/bill-images`, data);
export const createLadingExcel = (data: any) => http.post(`v1/customer/bill-ladings/create-list-bill`, data);
export const updateLadingExcel = (data: any) => http.put(`v1/customer/bill-ladings/update-list-bill`, data);
export const listLading = (params?: LadingParams) => http.get(`v1/customer/bill-ladings`, { params });
export const singleLading = (id: string) => http.get(`v1/customer/bill-ladings/${id}`);
export const updateLading = (id: string, data: any) => http.put(`v1/customer/bill-ladings/${id}`, data);
export const deleteLading = (id: string) => http.delete(`v1/customer/bill-ladings/${id}`);
export const calculateMoneyLading = (data: any) => http.post(`v1/bill-ladings/calculateMoney`, data);
export const singleLadingByCode = (code: string) => http.get(`v1/bill-ladings/search/${code}`);
export const listLadingByRowGuids = (rowGuids: string[]) => http.post(`v1/bill-ladings/by-row-guids`, { rowGuids });
export const listLadingNeedUpdate = (params: any) => http.get(`v1/bill-ladings/list-need-update`, { params });
export const scanLadingNeedUpdate = (ladingCode: any) => http.get(`v1/bill-ladings/scan-need-update/${ladingCode}`);

// draft
export const saveDraft = (data: Lading, account: any) => {
    let ladings = JSON.parse(appStorage.get(account) as any) || [];
    if (data.ladingCode && ladings.some((lading: Lading) => lading.ladingCode === data.ladingCode)) {
        message.error("Đã tồn tại mã vận đơn");
        return;
    }
    ladings = [...ladings, { ...data, id: (new Date()).valueOf() }];
    appStorage.set(account, JSON.stringify(ladings));
    message.success("Đã lưu đơn nháp");
}

export const listDraft = (account: any) => {
    return JSON.parse(appStorage.get(account) as any) || [];
}

export const singleDraft = (id: any, account) => {
    const ladings = JSON.parse(appStorage.get(account) as any) || [];
    return ladings.find((lading: any) => lading.id == id) || null;
}

export const deleteDraft = (id: any, account: any) => {
    let ladings = JSON.parse(appStorage.get(account) as any) || [];
    ladings = ladings.filter((lading: any) => lading.id != id);
    appStorage.set(account, JSON.stringify(ladings));
    message.success("Xóa đơn nháp thành công");
    return ladings;
}
